const e=["none","small","medium","large","full"],r={radius:{type:"enum",values:e,default:void 0}};export{e as radii,r as radiusPropDef};
//# sourceMappingURL=radius.prop.js.map
